import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { graphql } from '~/apollo/generated/v4';
import type { RefetchQueries } from '~/utils/graphql';

const DELETE_OTHER_WIKI = graphql(`
  mutation DeleteOtherWiki($id: ID!) {
    otherWikiDelete(id: $id) {
      result {
        id
      }
    }
  }
`);

export function DeleteOtherWiki({
  otherWikiId,
  children,
  onDeleteSuccess,
  refetchQueries,
}: {
  otherWikiId: number;
  children: (onDelete: () => void, loading: boolean) => JSX.Element;
  onDeleteSuccess?: () => unknown;
  refetchQueries?: RefetchQueries;
}) {
  const [deleteWikiPage, { loading }] = useMutation(DELETE_OTHER_WIKI, {
    variables: { id: otherWikiId },
    refetchQueries,
  });

  async function handleDelete() {
    try {
      await deleteWikiPage();
      toast.success('Other wiki page deleted successfully.');
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (err) {
      console.log('Error deleting wiki page', err);
      toast.error('There was a problem deleting the wiki page.');
    }
  }

  return children(handleDelete, loading);
}
